/**
 * Flavor accents pulled from the real Smash cup photography.
 * Used to bring the drinks' own color onto the dark base — never as a full background.
 */
export const FLAVORS = [
  { id: "tigers-blood", name: "Tiger's Blood", color: "#FF3B5C", image: "/brand/cup-rec-tigers-blood.png" },
  { id: "ocean-water", name: "Ocean Water", color: "#21C8F6", image: "/brand/cup-rec-ocean-water.png" },
  { id: "pink-starburst", name: "Pink Starburst", color: "#FF5FA2", image: "/brand/cup-rec-pink-starburst.png" },
  { id: "melonberry", name: "Melonberry", color: "#8CD94B", image: "/brand/cup-rec-melonberry.png" },
  { id: "dr-smashberry", name: "Dr. Smashberry", color: "#B4459B", image: "/brand/cup-rec-dr-smashberry.png" },
  { id: "drango", name: "Drango", color: "#FF8A1F", image: "/brand/cup-rec-drango.png" },
  { id: "white-gummy", name: "White Gummy", color: "#E8E2D4", image: "/brand/cup-rec-white-gummy.png" },
  { id: "cherry-limeade", name: "Cherry Limeade", color: "#E63946", image: "/brand/cup-rec-cherry-limeade.png" },
  { id: "watermelon-lychee", name: "Watermelon Lychee", color: "#FF6B81", image: "/brand/cup-rec-watermelon-lychee.png" },
  { id: "pina-colada", name: "Piña Colada", color: "#F7E7A6", image: "/brand/cup-rec-pina-colada.png" },
  { id: "cucumber-mint", name: "Cucumber Mint", color: "#57C98B", image: "/brand/cup-rec-cucumber-mint.png" },
  { id: "jolly-rancher", name: "Jolly Rancher", color: "#7FD4FF", image: "/brand/cup-rec-jolly-rancher.png" },
  { id: "pink-drink", name: "Pink Drink", color: "#FF9EC4", image: "/brand/cup-rec-pink-drink.png" },
  { id: "the-laker", name: "The Laker", color: "#A06CE4", image: "/brand/cup-rec-the-laker.png" },
];

/** Stable accent for any string key, so a section keeps its color between renders. */
export const accentFor = (key = "") => {
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) % 9973;
  return FLAVORS[hash % FLAVORS.length].color;
};
